export default "__VITE_ASSET__8eca6071__"